import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface CreateCustomKpiState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null | undefined
  data: undefined
}

const initialState: CreateCustomKpiState = {
  isLoading: true,
  error: null,
  httpStatus: null,
  data: undefined
}

const createCustomKpiSlice = createSlice({
  name: 'createCustomKpi',
  initialState,
  reducers: {
    createCustomKpiLoadingAction: (state) => {
      return {
        ...state,
        isLoading: true,
        error: null,
        httpStatus: 0,
        data: undefined
      }
    },
    createCustomKpiUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        data: action.payload.data
      }
    },
    createCustomKpiErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        ...state,
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        data: undefined
      }
    },
    createKpiReset: () => initialState
  }
})

export const {
  createCustomKpiLoadingAction,
  createCustomKpiUpdateAction,
  createCustomKpiErrorAction,
  createKpiReset
} = createCustomKpiSlice.actions

export default createCustomKpiSlice.reducer
